import HeaderPage from "./HeaderContainer";

export default HeaderPage;
